import { GradientDots } from '@statsbomb/kitbag-datavis';
import { useTranslation } from 'react-i18next';
import { EVENT_MAP_LEGEND_XG_LABELS } from '@/consts/visualisations';

export const EventMapXgGradient = () => {
  const { t } = useTranslation('visualisation');

  return (
    <GradientDots labelValues={EVENT_MAP_LEGEND_XG_LABELS} title={t('markerColouring.xg')} gradientName="thermometer" />
  );
};
